export const STATUS_LABELS = {
  live: 'Live',
  draft: 'Draft',
  sent: 'Sent',
  open: 'Open',
  closed: 'Closed',
  scheduled: 'Scheduled',
  launching: 'Launching',
  paused: 'Paused',
  aborted: 'Aborted',
}

export const STATUS_CLASS = {
  live: 'live',
  draft: 'draft',
  sent: 'sent',
  open: 'open',
  closed: 'closed',
  scheduled: 'draft',
  launching: 'draft',
  paused: 'closed',
  aborted: 'closed',
}

export const ENTITY_CONFIG = {
  Campaign: {
    Icon: SvgIconsCampaigns,
    iconClass: 'campaign',
    label: 'campaign',
    getStatus: (bookmark) => bookmark.status,
    getMetric: (bookmark) => {
      const count = bookmark.search?.targetCount
      if (count == null || count === 0) return null
      return { n: Number(count).toLocaleString(), lbl: 'recipients' }
    },
    getUrl: (bookmark) =>
      ['draft', 'scheduled'].includes(bookmark.status)
        ? `/admin/campaigns/${bookmark.id}/build`
        : `/admin/campaigns/${bookmark.id}/overview`,
  },
  Flow: {
    Icon: SvgIconsCampaigns,
    iconClass: 'campaign',
    label: 'flow',
    getStatus: (bookmark) => bookmark.status,
    getMetric: () => null,
    getUrl: (bookmark) => `/admin/flows/${bookmark.id}`,
  },
}

export const DEFAULT_VISIBLE = 3
